// Editorial
const EditorialNames = [
	// 'featured',
	// 'popular',
	// 'recent',
	// 'trending'
];

// Workspaces
export const workspaceFacetNames = [
	...EditorialNames,
	'role',
	'membership',
	'stats.totalFollowers',
	'stats.totalProjects',
];

export const workspaceFilterNames = [
	...EditorialNames,
	'role',
	'membership',
	'latitude',
	'longitude',
	'proximity',
	'stats.totalFollowers',
	'stats.totalProjects',
	'view',
];

// Users
export const userFacetNames = [...EditorialNames, 'role', 'membership', 'stats.totalFollowers', 'stats.totalProjects'];

export const userFilterNames = [
	...EditorialNames,
	'role',
	'membership',
	'latitude',
	'longitude',
	'proximity',
	'stats.totalFollowers',
	'stats.totalProjects',
	'view',
];
